import { Component, Listen, h, State, Prop, Element, Watch } from '@stencil/core';

/**
 * Badges help draw attention to important content and can provide additional context to UI elements.
 */
@Component({
  tag: 'som-list',
  styleUrl: 'som-list.scss',
  shadow: true,
})
export class SomList {
  @Element() el: HTMLElement;
  childEl: HTMLElement;

  /**
   * This property determines what style the list will use.
   */
  @Prop() type: 'header' | 'panel' | 'dropdown' | 'sidebar' = 'panel'; 

  @State() isSubListOpen: boolean = false;
  
  listEl;

  componentWillLoad() {
    this.injectAttrs();
  }

  @Watch('type')
  attrsUpdated() {
    this.injectAttrs();
  }

  /**
   * If the slot changes, someone adds or removes items, process the attributes again
   */
  handleSlotChange() {
    this.injectAttrs();
  }

  /**
   * Loop through list items and add appropriate type attribute
   */
  injectAttrs() {
    this.el.childNodes.forEach(element => {
      element["type"] = this.type;
    });  
  }

  /**
   * Listen for when the parent list item is open and hide/show list items that are no longer displayed
   * Hiding the items helps keyboard navigation
   */
  @Listen('listOpened')
  listOpenedHandler() {
    this.isSubListOpen = true;

    let levelOneNav = Array.prototype.slice.call(this.listEl.querySelectorAll('som-list-item:not(.open), som-list-parent-item:not(.open)'));
    levelOneNav.map(item => {
      item.style.display = 'none';
    });

    let levelTwoNav = Array.prototype.slice.call(this.listEl.querySelectorAll('som-list-item.open'));
    levelTwoNav.map(item => {
      item.style.display = 'unset';
    });       
  }

   /**
   * Listen for when the parent list item is about and hide/show list items that are no longer displayed
   * Hiding the items helps keyboard navigation
   */
  @Listen('beforeListClosed')
  listClosedHandler() {
    this.isSubListOpen = false;
    let levelOneNav = Array.prototype.slice.call(this.listEl.querySelectorAll('som-list-item:not(.open), som-list-parent-item:not(.open)'));
    levelOneNav.map(item => {
      item.style.display = 'unset';
    });

    let levelTwoNav = Array.prototype.slice.call(this.listEl.querySelectorAll('som-list-item.closed'));
    levelTwoNav.map(item => {
      item.style.display = 'none';
    });    
  }

  render() {
    return (
      <div class={`list-container ${this.type}`} ref={(el) => this.listEl = el}>
        <slot onSlotchange={() => this.handleSlotChange()}></slot>
      </div>
    );
  }
}